

import Vue from 'vue'
import router from './router'
import store from '@/store'
import api from '@/api'
import IconComponent from '@/icons'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import qs from 'qs'
import axios from 'axios'
import echarts from 'echarts'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'mint-ui/lib/style.css'
import 'babel-polyfill'
import VueClipboard from 'vue-clipboard2'
import VueScroller from "vue-scroller";
import App from './app'




Vue.use(VueClipboard)
Vue.use(VueScroller);
Vue.prototype.$messageSelf = function (type, msg) {
this.$message({
type: type,
message: msg,
duration: 1500
})
}

Vue.prototype.$echarts = echarts

Vue.component(IconComponent.name, IconComponent)
Vue.use(VueAwesomeSwiper)

Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.use(ElementUI);
Vue.config.productionTip = false


window.addEventListener('message', function (e) {
if (e.data.viewType === '1') {
window.location.reload()
}
}, false)


global.isOrangeStyle = false
axios.defaults.withCredentials = true
Vue.prototype.$qs = qs
Vue.prototype.$http = axios
Vue.prototype.$toast = {
show(text, time) {
if (!time) {
time = 3000;
}
Vue.$vux.toast.show({
width: 'auto',
type: 'text',
time: time,
position: 'middle',
text
})
}
}

Vue.prototype.$loading = {
show(text) {
Vue.$vux.loading.show({
text
})
},
hide() {
Vue.$vux.loading.hide()
}
}

Vue.prototype.$alert = {
show(text) {
Vue.$vux.alert.show({
title: '提示',
content: text
})
}
};

router.beforeEach(function (to, from, next) {
store.dispatch('updateLoadingStatus', true)
next()
})

router.afterEach(router => {
if (router.name === 'Operating' || router.name === 'Cash' || router.name === 'Gold') {
store.dispatch('switchTabbarShow', false)
} else {
store.dispatch('switchTabbarShow', false)
}
window.setTimeout(function () {
store.dispatch('updateLoadingStatus', false)
}, 1)
})


window.backToPrevUI = function () {

}

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})

if (navigator.onLine) {
console.log(1)
} else {
console.log(2)
}



// WEBPACK FOOTER //
// ./src/main.js